var map = {
	"./Client Orders.svg": "b25e",
	"./Clients.svg": "a254",
	"./Dashboard.svg": "6e7e",
	"./Inventory.svg": "d09f",
	"./Orders.svg": "c077",
	"./Price List.svg": "b5b3",
	"./Purchase Orders.svg": "1145",
	"./Settings.svg": "e057",
	"./add.svg": "6828",
	"./arrow.svg": "1106",
	"./edit.svg": "66d5",
	"./logo.svg": "1ae4",
	"./menu.svg": "869f",
	"./user.svg": "f41a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0591";